import React, { FC } from "react";

import { TextButton } from "./TextButton";

type Option = {
  label: string;
  onClick: () => void;
  isActive: boolean;
};

type Props = {
  label: string;
  leftOption: Option;
  rightOption: Option;
};

export const NavigationToggleSwitch: FC<Props> = ({ label, leftOption, rightOption }) => {
  return (
    <div className="flex text-[13px]">
      <div className="bg-gray-200 px-4 py-2 whitespace-nowrap">{label}</div>
      <div className="bg-white px-4 py-2 flex items-center space-x-4">
        <TextButton onClick={leftOption.onClick} isActive={leftOption.isActive}>
          {leftOption.label}
        </TextButton>
        <TextButton onClick={rightOption.onClick} isActive={rightOption.isActive}>
          {rightOption.label}
        </TextButton>
      </div>
    </div>
  );
};
